import { Appointment } from '@myapp/contract'

function getBlockMinutes(appt: Appointment) {
  const ws = new Date(appt.plannedStart)
  const startMin = ws.getHours() * 60 + ws.getMinutes() - appt.plannedTravelDuration
  const endMin = ws.getHours() * 60 + ws.getMinutes() + appt.plannedWorkDuration + appt.plannedDepartureDuration
  return { startMin, endMin }
}

export function computeTransfer(appointments: Appointment[]): {
  transferTravel: Set<string>
  transferDeparture: Set<string>
} {
  const transferTravel = new Set<string>()
  const transferDeparture = new Set<string>()

  if (appointments.length < 2) return { transferTravel, transferDeparture }

  const sorted = [...appointments].sort(
    (a, b) => getBlockMinutes(a).startMin - getBlockMinutes(b).startMin,
  )

  for (let i = 0; i < sorted.length - 1; i++) {
    const curr = sorted[i]
    const next = sorted[i + 1]
    const currBlock = getBlockMinutes(curr)
    const nextBlock = getBlockMinutes(next)

    if (currBlock.endMin >= nextBlock.startMin) {
      if (curr.plannedDepartureDuration > 0 && next.plannedTravelDuration === 0) transferDeparture.add(curr.id)
      if (next.plannedTravelDuration > 0 && curr.plannedDepartureDuration === 0) transferTravel.add(next.id)
    }
  }

  return { transferTravel, transferDeparture }
}
